import { create } from "zustand";

export const useModalStore = create((set) => ({
  modalType: "",
  modalProps: {},
  setModal: (modalType, modalProps) =>
    set(() => ({ modalType: modalType, modalProps: modalProps })),
  hideModal: () => set(() => ({ modalType: "", modalProps: null })),
}));
